import React from "react"
import Commercial from "../../components/pages/development/commercial"

const CommercialPage = (props) => <Commercial {...props} />

export default CommercialPage